import { createSelector } from '@reduxjs/toolkit';
import { useQuery } from '@tanstack/react-query';
import { useCourseBuilder } from './store.js';
import { getAllCoursesQuery } from '../api/query.get-all.js';

const selectCurrentCourse = createSelector(state => state.selectedCourseId, (state, courses) => courses, (selectedCourseId, courses) => courses?.find(it => it.id === selectedCourseId));
function useSelectedCourse() {
  const {
    data
  } = useQuery(getAllCoursesQuery.useQueryConfig());
  return useCourseBuilder(state => selectCurrentCourse(state, data));
}

export { useSelectedCourse };
//# sourceMappingURL=selectors.js.map
